var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mx-n2 mx-md-0",attrs:{"id":"feed"}},[_c('Feed',{staticClass:"pt-md-3 transition-up-1",attrs:{"query":_vm.query,"feedName":_vm.name,"roomName":`feed-${_vm.name}`}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }